import injectSheet from 'react-jss'
import V1SelectField from './V1SelectField'
import styles from './V1SelectField.styles'

export default injectSheet(styles)(V1SelectField)
